import { FC } from 'react';
import { useSelector } from 'react-redux';

import { State } from 'redux/initialState';
import { useTranslate } from 'hooks/useTranslate';

import ApiSelector from 'modules/ai/pages/SocietyAiAgent/components/ApiSelector';
import ComposerField from 'modules/ai/components/ComposerField';
import { useSocietyAiAgentPage } from 'modules/ai/pages/SocietyAiAgent/context/SocietyAiAgentPageContext';

import isSuperAdmin from 'utils/isSuperAdmin';

type FloatingComposerProps = {
  placeholder?: string;
  autoFocus?: boolean;
};

const FloatingComposer: FC<FloatingComposerProps> = ({
  placeholder = 'CHATBOT_InputPlaceholder',
  autoFocus = false,
}) => {
  const { t } = useTranslate();
  const { data, actions } = useSocietyAiAgentPage();

  const user = useSelector((state: State) => state.user) || null;

  const leadingSlot = isSuperAdmin(user) && (
    <>
      <ApiSelector />
      <div className="navi-composer__divider" />
    </>
  );

  return (
    <ComposerField
      variant="agent"
      value={data.inputText}
      onChange={actions.handleChangeInputText}
      onSubmit={actions.handleSendMessage}
      placeholder={t(placeholder)}
      disabled={data.isThinking}
      autoFocus={autoFocus}
      leadingSlot={leadingSlot}
    />
  );
};

export default FloatingComposer;
